import { Component, OnInit, Optional, TemplateRef, ViewChild, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-pricing-info',
  templateUrl: './pricing-info.component.html',
  styleUrls: ['./pricing-info.component.scss']
})
export class PricingInfoComponent implements OnInit{

  @ViewChild('icon') icon: TemplateRef<any>;
  details: any;
  pricingPlanData;
  agentId: any;
  readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

  constructor(
    @Optional() public modalService: NzModalRef,
  ) { }

  ngOnInit(): void {
    this.modalService.componentInstance = { ...this.modalService.componentInstance, ...this.nzModalData };
    this.pricingPlanData = this.modalService?.componentInstance?.data.pricingData;
    this.details =this.pricingPlanData.currentPricingPlan;
  }

  cancelModal() {
		this.modalService.destroy();
	}

}
